export const CHANGE_BUILDER_FILTER = 'CHANGE_BUILDER_FILTER';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const ADD_DISCARD_MODAL = 'ADD_DISCARD_MODAL';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const UPDATE_BUILDER_FILTER_DATA = 'UPDATE_BUILDER_FILTER_DATA';
export const SET_COMPANY_FILTER = 'SET_COMPANY_FILTER';
